import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage, STORAGE_PREFIX } from "../firebase";

/** Upload an image (File or Blob) to quiz/<folder>/<filename>; returns its URL. */
export async function uploadQuizImage(
  file: File | Blob,
  folder = "questions",
  name?: string,
): Promise<string> {
  const raw = name || (file instanceof File ? file.name : `image-${Date.now()}.png`);
  const safe = raw.replace(/[^a-zA-Z0-9.\-_]/g, "_");
  const path = `${STORAGE_PREFIX}/${folder}/${Date.now()}_${Math.random()
    .toString(36)
    .slice(2, 7)}_${safe}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type || "image/png" });
  return getDownloadURL(r);
}
